export const wrapTooltipContent = (content, additionClass) => {
  return `<div class="text-[15px] px-2 py-2 max-w-[350px] min-w-[100px] flex justify-center items-center break-words whitespace-normal ${additionClass}">
    ${content}
  </div>`;
};
